import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=81208fc6&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"
import style0 from "./upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81208fc6')) {
      api.createRecord('81208fc6', component.options)
    } else {
      api.reload('81208fc6', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=81208fc6&", function () {
      api.rerender('81208fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/task/customerTask/upload.vue"
export default component.exports